const order = {
  state: {
      ConnectionId:"",
      onlineDoctorList:[],
      unReadMsg:[]
  },
  mutations: {
    // 存储ConnectionId
    saveConnectionId(state,payload){
        state.ConnectionId=payload;
        sessionStorage.setItem("connectionId",payload)
    },
    saveOnlineDoctorList(state,payload){
        state.onlineDoctorList=payload
      sessionStorage.setItem("onlineDoctorList",JSON.stringify(state.onlineDoctorList))
    },
    changeDoctorState(state,payload){
     let doctors = state.onlineDoctorList.map(e=>{
        if(payload.some(item=>item.userId===e.DoctorId)){
          e['isOnline']=true
        }else{
          e['isOnline']=false
        }
        return e
      })
      state.onlineDoctorList=doctors;
      sessionStorage.setItem("onlineDoctorList",JSON.stringify(state.onlineDoctorList))
    },
    deleteUnReadMsg(state,payload){
      state.onlineDoctorList = state.onlineDoctorList.map(e=>{
        if(e.DoctorId===payload){
          e['unReadMsg'].length=[]
        }
        return e
      })
      sessionStorage.setItem("onlineDoctorList",JSON.stringify(state.onlineDoctorList))
    },
    setUnReadMsg(state,payload){
    state.onlineDoctorList =  state.onlineDoctorList.map(e=>{
        if(e.DoctorId===payload.data.userId){
          e['unReadMsg'].push(payload)
        };
        return e
      })
      sessionStorage.setItem("onlineDoctorList",JSON.stringify(state.onlineDoctorList))
    }
  }
}
export default order



// WEBPACK FOOTER //
// ./src/store/modules/onlineConsultant.js